import { useGameStore } from "@/store";
import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
  type PropsWithChildren,
} from "react";
import superjson from "superjson";

import type { Room, RoomInTransit } from "@/server/models/room";
import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
const URL =
  process.env.NODE_ENV === "production" ? undefined : "http://localhost:3000";

export const createSocket = () => io(URL, {});

type Websocket = ReturnType<typeof createSocket>;
const WebsocketContext = createContext<Websocket | null>(null);

export function WebsocketProvider({ children }: PropsWithChildren) {
  const [websocket, setWebsocket] = useState<Websocket | null>(null);

  // const navigate = useNavigate();
  const setRoom = useGameStore((store) => store.setRoom);
  const setUserId = useGameStore((store) => store.setUserId);

  const isConnecting = useRef(false);
  useEffect(() => {
    if (!!websocket || isConnecting.current) return;
    isConnecting.current = true;

    const socket = io(URL);

    const id = window.localStorage.getItem("chesskcd-user-id");
    socket.emit("CONNECT", { id }, (data: { id: string }) => {
      if (data.id) {
        setUserId(data.id);
        window.localStorage.setItem("chesskcd-user-id", data.id);
      }
    });

    socket.on("OPEN", (data) => {});
    socket.on("CLOSE", (data) => {});
    socket.on("ROOM_UPDATE", (roomInTransit: RoomInTransit) => {
      const board: Room["board"] = superjson.parse(roomInTransit.board);
      const room: Room = {
        ...roomInTransit,
        board,
      };
      setRoom(room ?? null);
    });

    setWebsocket(socket);
  }, [setWebsocket, websocket]);

  return <WebsocketContext value={websocket}>{children}</WebsocketContext>;
}

export function useWebsocketContext() {
  return useContext(WebsocketContext);
}
